<template>
  <div id="routesadd" class="longInfo">
    <md-toolbar class="listBar">
      <router-link tag="md-button" class="md-icon-button" to="/">
        <md-icon>close</md-icon>
      </router-link>
      <h2 class="md-title">Add testing routes</h2>
    </md-toolbar>
    <form novalidate @submit.stop.prevent="">

      <md-list style="position:relative; top:54px;">
        <md-list-item style="background-color:rgb(231, 244, 245);">
          <span class="md-subheading">Select sector</span>
        </md-list-item>

        <md-list-item>
          <md-input-container>


          <md-select v-if="rawSectors" style="padding:0px;" name="userSectors" id="userSectors" class="what" placeholder="sektor" v-model="whatSector">

            <md-subheader>Sektor</md-subheader>
            <md-option style="cursor:pointer;" v-for="(selectSectors, index) in rawSectors"
                      @selected="selectSector()"
                      :key="index"
                      :value="selectSectors.properties.sectorLink">{{ selectSectors.properties.name}}
            </md-option>
          </md-select>
          </md-input-container>
        </md-list-item>

        <md-list-item style="background-color:rgb(231, 244, 245);">
          <span class="md-subheading">Create fake routes</span>
          <md-button @click="addRoutes()" class="md-icon-button md-primary">
            <md-icon>check_circle</md-icon>
          </md-button>
        </md-list-item>

      <md-list-item>
        <md-input-container>
          <label>Routes prefix</label>
          <md-input v-model="fakeRoutes.prefix"></md-input>
        </md-input-container>
      </md-list-item>
      <md-list-item>
        <md-input-container>
          <label>Number of routes</label>
          <md-input type="number" v-model="fakeRoutes.count"></md-input>
        </md-input-container>
      </md-list-item>


      <md-list-item style="background-color:rgb(231, 244, 245);">
        <span class="md-subheading">Create fake rating statements</span>
        <md-button @click="addRatings()" class="md-icon-button md-primary">
          <md-icon>check_circle</md-icon>
        </md-button>
      </md-list-item>
      <md-list-item>
        <md-input-container>
          <label>Max number per route</label>
          <md-input type="number" v-model="fakeRating.maxStatements"></md-input>
        </md-input-container>
      </md-list-item>

      <md-list-item>
        <md-switch type="submit" v-model="fakeRating.randomUsers" name="my-test9" class="md-primary">Random users</md-switch>
      </md-list-item>

      <md-list-item style="background-color:rgb(231, 244, 245);">
        <span class="md-subheading">Create fake users</span>
        <md-button @click="addUsers()" class="md-icon-button md-primary">
          <md-icon>check_circle</md-icon>
        </md-button>
      </md-list-item>
      <md-list-item>
        <md-input-container>
          <label>Name prefix</label>
          <md-input v-model="fakeUsers.prefix"></md-input>
        </md-input-container>
      </md-list-item>
      <md-list-item>
        <md-input-container>
          <label>Number of users</label>
          <md-input type="number" v-model="fakeUsers.count"></md-input>
        </md-input-container>
      </md-list-item>

    </md-list>

  </form>


  </div>
</template>

<script>
import { mapState } from 'vuex'


export default {
  name: 'routesadd',
  data: () => ({

    fakeRating: {
      maxStatements: 20,
      randomUsers: true
    },

    fakeUsers: {
      prefix: '',
      count: 0,
    },

    fakeRoutes: {
      prefix: '',
      count: 0,
    },

    whatSector: null,
    selectedSector:null,
    rawSectors: [],
    startLink: 'climbo-backend/v1/sectormap',
  }),

  mounted(){
    this.$http.get(process.env.BACKEND_URL + this.startLink)
    .then(function (response) {
        this.rawSectors = response.data.features
        var fakes = this.rawSectors[0].properties.sectorLink.split('/')[3]
        console.log('sectors', this.rawSectors, fakes)
      }, response => {
        console.log('not success')
      })

  },

  methods: {

    selectSector() {
      // console.log('selected Sector', this.whatSector)
      this.selectedSector = this.whatSector.split('/')[3]
      console.log('selected Sector', this.selectedSector)
    },

    addRoutes() {
      var moreRoutes = JSON.stringify(this.fakeRoutes)
      //console.log('fakeRoutes', moreRoutes)

      var linkRoutes = '/climbo-backend/v1/debug/sector/' + this.selectedSector + '/fake/routes'+ '/create'

        this.$http.put(linkRoutes, moreRoutes)
          .then((response) => {
            console.log('success add routes')
          },
          (response) => {
            console.log('not success')
          })
      },

    addUsers() {
      var moreUsers = JSON.stringify(this.fakeUsers)
      // console.log('fakeUsers', moreUsers)
      var linkUsers = '/climbo-backend/v1/debug/fake/users'+ '/create'

        this.$http.put(linkUsers, moreUsers)
          .then((response) => {
            console.log('success add users')
          },
          (response) => {
            console.log('not success')
          })
      },

      addRatings () {
        var moreRatings = JSON.stringify(this.fakeRating)
        // console.log('fakeRoutes', moreRatings)
        var linkRatings = '/climbo-backend/v1/debug/sector/' + this.selectedSector + '/fake/ratingstatements' + '/create'

          this.$http.put(linkRatings, moreRatings)
            .then((response) => {
              console.log('success add rattings')
            },
            (response) => {
              console.log('not success')
            })
        }
  }
}

</script>

<style>

</style>
